import { Injectable } from "@angular/core";
import { NdmsSafeSubscriber } from "projects/shared/core/interfaces/ndms-safe-subscriber";
import { NdmsRoleModel } from "../models/ndms-role.model";
import { UserModel } from "projects/shared/core/app/api/models/user-model";
import { UserQueryModel } from '../models/user-query.model';
import { RoleQueryResponseModel } from "projects/shared/core/app/api/models/role-query-response-model";
import { UserModelEditorViewModel } from "projects/shared/core/app/api/models/user-model-editor-view-model";
import { UserModelImportModel } from "projects/shared/core/app/api/models/user-model-import-model";
import { UserModelListEditorViewModel } from "projects/shared/core/app/api/models/user-model-list-editor-view-model";
import { UserQueryResponseModel } from "projects/shared/core/app/api/models/user-query-response-model";
import { UserService } from "projects/shared/core/app/api/services/user.service";

@Injectable()
export class NdmsUsersService extends NdmsSafeSubscriber {

  constructor(
    private _userService: UserService) {
    super();
  }

  addRoleToUser(userKey: string, role: NdmsRoleModel) {
    return new Promise<UserModelEditorViewModel>((resolve, reject) => {
      let params: UserService.AddRoleParams = {
        userKey: userKey,
        RoleName: role.roleName,
        RoleKey: role.roleKey,
        DisplayName: role.displayName
      }
      this.safeSubscribe(this._userService.AddRole(params), data => {
        resolve(data), error => reject(error);
      });
    });
  }

  getRoles() {
    return new Promise<RoleQueryResponseModel>((resolve, reject) => {
      this.safeSubscribe(this._userService.GetAllRoles(), data => {
        resolve(data), error => reject(error);
      });
    });
  }

  query(filter: UserQueryModel) {
    return new Promise<UserQueryResponseModel>((resolve, reject) => {
      let params: UserService.QueryParams = {
        AccountStatus: filter.accountStatus,
        UserName: encodeURIComponent(filter.userName),
        FirstName: encodeURIComponent(filter.firstName),
        LastName: encodeURIComponent(filter.lastName)
      } || {};
      this.safeSubscribe(this._userService.Query(params), data => {
        resolve(data), error => reject(error);
      });
    });
  }

  removeRoleFromUser(userKey: string, role: NdmsRoleModel) {
    return new Promise<UserModelEditorViewModel>((resolve, reject) => {
      let params: UserService.RemoveRoleParams = {
        userKey: userKey,
        RoleName: role.roleName,
        RoleKey: role.roleKey,
        DisplayName: role.displayName
      };
      this.safeSubscribe(this._userService.RemoveRole(params), data => {
        resolve(data), error => reject(error);
      });
    });
  }

  saveUser(ndmsUser: UserModel) {
    return new Promise<UserModelEditorViewModel>((resolve, reject) => {
      let params: UserService.SaveParams = {
        userKey: ndmsUser.key,
        userModel: {
          userName: ndmsUser.userName,
          firstName: ndmsUser.firstName,
          lastName: ndmsUser.lastName
        }
      };
      this.safeSubscribe(this._userService.Save(params), data => {
        resolve(data), error => reject(error);
      });
    });
  }

  upload(userModels: UserModelImportModel) {
    return new Promise<UserModelListEditorViewModel>((resolve, reject) => {
      this.safeSubscribe(this._userService.Upload(userModels), data => {
        resolve(data), error => reject(error);
      });
    });
  }

}
